module.exports = __webpack_public_path__ + "img/stkaave.1b4dbb78.svg";